import { useMemo } from 'react';
import { navigatorTypes } from './navigator.types';
import {
    AboutPage,
    BlogsPage,
    ContactPage,
    HomePage,
    ServicesPage,
    LoginPage,
    PoliciesPage,
    MembersPage,
    ForceChangePassword,
    AddBlogsPage
} from '../components';

interface NavigationProps {
    path: navigatorTypes;
    component: React.FC<{}>;
}

export const useNavigator: () => {
    public: Array<NavigationProps>;
    admin: Array<NavigationProps>;
    employee: Array<NavigationProps>;
} = () => {
    return useMemo(() => {
        return {
            public: [
                {
                    path: '/',
                    component: HomePage
                },
                {
                    path: '/about',
                    component: AboutPage
                },
                {
                    path: '/blogs',
                    component: BlogsPage
                },
                {
                    path: '/contact',
                    component: ContactPage
                },
                {
                    path: '/services',
                    component: ServicesPage
                },
                {
                    path: '/login',
                    component: LoginPage
                }
            ],
            admin: [
                {
                    path: '/members/view',
                    component: MembersPage
                },
                {
                    path: '/policies/admin',
                    component: PoliciesPage
                },
                {
                    path: '/blogs/add',
                    component: AddBlogsPage
                },
                {
                    path: '/force-change-password',
                    component: ForceChangePassword
                }
            ],
            employee: [
                {
                    path: '/policies',
                    component: PoliciesPage
                },
                {
                    path: '/force-change-password',
                    component: ForceChangePassword
                }
            ]
        };
    }, []);
};
